
import { Component, Vue } from 'vue-property-decorator'

@Component({
	name: 'BFooter'
})
export default class extends Vue {}
